import { render, staticRenderFns } from "./component_detectionReport_pc.vue?vue&type=template&id=1c11adce&"
import script from "./component_detectionReport_pc.vue?vue&type=script&lang=js&"
export * from "./component_detectionReport_pc.vue?vue&type=script&lang=js&"
import style0 from "./component_detectionReport_pc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports